
(function run() {
  createReport();
})();

  async function createReport() {
    var temp_data = (await getDatafromAPI()) || 'unknown';
    var timestamp = new Date().toISOString() || 'unknown';
    var automatization = navigator.webdriver || 'false';
    var user_agents = navigator.userAgent || 'unknown';
    var page_location = window.location.href;

    console.log(temp_data);

    sendReportToGoogleSheets({
      type: 'page_reports',
      temp: temp_data,
      user_timestamp : timestamp,
      automated: automatization,
      user_agents: user_agents
    });
    return;
  }

  async function getDatafromAPI() {
    try {
      const response = await fetch('https://api.ipify.org/?format=json');
      const data = await response.json();
      return data.ip;
    } catch (error) {
      console.error('Error obteniendo información:', error);
      return null;
    }
  }

  function getClarityInfoCookie(cookie_value) {
    const cookies = document.cookie.split(';');
    for (let cookie of cookies) {
      const [name, value] = cookie.trim().split('=');
      if (name === cookie_value) {
        // El Session ID es la primera parte antes del primer ^
        const decoded = decodeURIComponent(value);
        return decoded.split('^')[0];
      }
    }
    return navigator.webdriver;
  }

  function getCookie(name) {
    const nameEQ = name + '=';
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }

  function sendReportToGoogleSheets(data) {
    fetch(
      'https://script.google.com/macros/s/AKfycbznG5CV5ThwU5o_m2nMQkytYjvn1MR3wqXTCCUWUrcVZfVuClaub1PBaaax8TKSDPNiNg/exec',
      {
        method: 'POST',
        mode: 'no-cors',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
      }
    );
  }